import React from 'react';
import { PageTemplate } from '@kallidus/common';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import './ApplicationPage.less';
import { string } from 'prop-types';

export default function ApplicationPage({ className, ...props }) {
  const { t } = useTranslation();
  const copyrightText = t('page-footer.copyright-message-with-year', { year: new Date().getFullYear() });

  return <PageTemplate {...props} className={clsx('application-page', className)} footerProps={{ copyrightText }} />;
}

ApplicationPage.propTypes = {
  className: string,
};
